<template>
  <div class="indexPage footerPosition">
    <div class="pageTipMar">
      <p>
        <img src="../../../assets/img/loading.gif" style="width: 36px; height: 36px" />
      </p>
      <p></p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import footerInfo from '../public/footerInfo'
import { post, fetch, Del, put } from "../../../ask/axios";
import { fileSteamDownload } from '@/utils/download'

export default {
  components: { footerInfo },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      isShowContent: 1,
    }

  },
  created() {
    if (this.$route.query.abUs) {
      this.isShowContent = this.$route.query.abUs
    }
    if (this.$route.query.Orderid) {
      this.PrintLabelAPI();
    }

  },
  methods: {
    //打印标签
    PrintLabelAPI() {

      let that = this;
      //订单号
      var wayBillNOs = that.$route.query.Orderid;

      let WayTpye = 1 //1:快递，3：空运 ,账单类型
      if (that.$route.query.WaybillType == 1) {
        WayTpye = 1
      } else if (that.$route.query.WaybillType == 3) {
        WayTpye = 3
      }


      var width = 210;
      var height = 297;
      that.api.param = {
        Width: width,
        Height: height,
        WaybillNo: wayBillNOs,
        WaybillType: WayTpye,//1:快递，3：空运
      };
      that.api.url = that.$api05 + "/api/Make/PDFLable";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Data) {
          let url = res.Data
          let name = url.split('/')[url.split('/').length - 1]
          // fileSteamDownload(that, {
          //   FullPath: url, // 路径
          //   CurrentFileName: name // 文件名称
          // }, name);
          location.href = url
        } else {
          that.$confirm(res.MessageEn, '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false
        }
      })
    },

  }
}
</script>
<style scoped>
@import "../../../assets/css/about.css";
</style>



// WEBPACK FOOTER //
// src/components/reception/otherPage/printPage.vue